export default "__VITE_ASSET__0PAqArcK__"